import { render, staticRenderFns } from "./ItemItems.vue?vue&type=template&id=406ef04e&"
import script from "./ItemItems.vue?vue&type=script&lang=js&"
export * from "./ItemItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports